import { useContext } from "react";
import { PlausibleContext } from "../Contexts/PlausibleContext";

/**
 * Hook to access Plausible Analytics tracking functionality
 * Provides trackEvent and trackPageview methods for custom event tracking
 * @returns {Object} { trackEvent, trackPageview, initialized }
 */
export const usePlausible = () => {
  const context = useContext(PlausibleContext);

  if (!context) {
    throw new Error("usePlausible must be used within PlausibleProvider");
  }

  return context;
};
